import React from "react";
import Checkbox from "react-bootstrap/lib/Checkbox";
// import "pretty-checkbox/dist/pretty-checkbox.min.css";
// import { Switch } from "pretty-checkbox-react";
import styles from "./NodeTypeSelect.module.css";
import loc from "i18next";

const NodeTypeSelect = ({ checked, onChange }) => (
    <Checkbox
        checked={checked}
        onChange={onChange}
        className={styles.container}
    >
        {loc.t("search:nodeType")}
    </Checkbox>
);

NodeTypeSelect.displayName = "NodeTypeSelect";
export default NodeTypeSelect;
